<template>
  <rest-list :payload="fetchEndpoint" @row-click="rowClick">
    <el-table-column
      :label="$t('Integrations_Field_Integration')"
      class="integration-column"
    >
      <template slot-scope="scope">
        <div class="integration-container">
          <div class="integration-logo">
            <img class="integration-logo-image" :src="getImageUrl(scope.row)" />
          </div>
          <span class="integration-title">{{ scope.row.name }}</span>
        </div>
      </template>
    </el-table-column>

    <el-table-column
      :label="$t('Integrations_Field_Status')"
      align="center"
      width="200"
    >
      <template slot-scope="scope">
        <el-tag
          v-if="
            Integrations[scope.row.type] !== undefined &&
              Integrations[scope.row.type].requiresApproval &&
              !scope.row.params.approved
          "
          type="warning"
          effect="plain"
        >
          {{ $t('Integrations_Gig_Text_Awaiting_Approval') }}
        </el-tag>
        <el-tag
          v-else
          :type="scope.row.active ? 'success' : 'info'"
          effect="plain"
        >
          {{
            scope.row.active
              ? $t('Integrations_Field_StatusActive')
              : $t('Integrations_Field_StatusInactive')
          }}
        </el-tag>
      </template>
    </el-table-column>
  </rest-list>
</template>

<script>
import RestList from '@/common/components/rest/RestList'
import Integrations from '@/modules/integrations/types'
import { projectEndpoint, projectRoute } from '@/core/helpers'
import RestApi from '@/core/services/RestApi'

export default {
  name: 'IntegrationsList',

  components: {
    RestList
  },

  data() {
    return {
      Integrations,
      dynamicIntegrationsImages: null
    }
  },

  mounted() {
    this.fetchDynamicIntegrations().then(data => {
      const filteredData = {}
      data.forEach(item => {
        filteredData[item.id] = item.image_url
      })
      this.dynamicIntegrationsImages = filteredData
    })
  },

  computed: {
    fetchEndpoint() {
      const params = this.buildEndpointParams()
      return projectEndpoint({
        method: 'get',
        url: `integrations`,
        params
      })
    },

    clickable() {
      return this.$can('viewProjectTechnical')
    }
  },

  methods: {
    getImageUrl(row) {
      if (
        Integrations[row.type] &&
        typeof Integrations[row.type].image !== 'undefined'
      ) {
        return Integrations[row.type].image
      } else if (this.dynamicIntegrationsImages) {
        return this.dynamicIntegrationsImages[row.dynamic_integration_id]
      }
    },

    async fetchDynamicIntegrations() {
      const result = await RestApi.get(
        `projects/${this.$route.query.project_id}/integrations/dynamic-promotions`
      )
      return result.data
    },

    buildEndpointParams() {
      const params = {}
      if (this.$route.query.dynamic_integration_id !== undefined) {
        params.dynamic_integration_id = this.$route.query.dynamic_integration_id
      } else {
        params.type = this.$route.query.type
      }
      return params
    },

    rowUpdateRoute(row) {
      return projectRoute({
        name: 'IntegrationOverview',
        query: { id: row.id }
      })
    },

    rowClick(row) {
      if (this.clickable) {
        let route = this.rowUpdateRoute(row)
        this.$router.push(route)
      }
    }
  }
}
</script>

<style scoped>
>>> .el-table__row:hover {
  cursor: pointer;
}

.integration-container {
  display: flex;
  align-items: center;
}

.integration-title {
  margin-left: 20px;
  font-weight: normal;
  font-size: 14px;
}

.integration-logo {
  height: 35px;
  width: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.integration-logo-image {
  max-width: 90%;
  max-height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/modules/integrations/pages/IntegrationsList.vue